import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

const useStyles = makeStyles((theme) => ({
  skeleton: {
    backgroundColor: theme.palette.background.paper,
  },
  cell: {
    padding: theme.spacing(2),
  },
}))

const TableSkeleton = () => {
  const classes = useStyles()
  const rows = 5
  const columns = 8

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {[...Array(columns)].map((_, i) => (
              <TableCell key={`header-${i}`} className={classes.cell}>
                <Skeleton
                  variant="text"
                  width={Math.floor(Math.random() * (120 - 80) + 80)}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(rows)].map((_, rowIndex) => (
            <TableRow key={`row-${rowIndex}`}>
              {[...Array(columns)].map((_, colIndex) => (
                <TableCell
                  key={`cell-${rowIndex}-${colIndex}`}
                  className={classes.cell}
                >
                  <Skeleton
                    variant="text"
                    width={Math.floor(Math.random() * (100 - 60) + 60)}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default TableSkeleton
